import React from 'react';
import { OPZET_API_URL } from '../../../shared/config/constants';
import { AddressFull } from '../../../shared/types/opzet';

const useDownloadUrl = (address: AddressFull, date: Date) => {
  const downloadPdfUrl = React.useMemo(() => {
    if (!address) {
      return null;
    }

    const {
      postcode,
      huisnummer,
      toevoeging,
      huisletter,
    } = address;

    return `${OPZET_API_URL}/kalender/${postcode}:${huisnummer}:${huisletter}:${toevoeging}/pdfkalender/${date.getFullYear()}`;
  }, [address, date]);

  return downloadPdfUrl;
};

export default useDownloadUrl;
